import React from 'react'
import './PostHero.scss'

export class PostHero extends React.Component {
  render() {
    const { post } = this.props
    return (
      <div
        className="post-hero"
        style={{ backgroundImage: post.type === 'Podcast' ? 'url(/cloud_geometric.jpg)' : (post.heroImage && post.heroImage.fluid ? 'url(' + post.heroImage.fluid.src + ')' : 'url(/cloud_geometric.jpg)') }}
      >
        <div className="overlay" />
      </div>
    )
  }
}

export default PostHero
